export default (theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        '&:hover span': {
            textDecoration: 'underline',
        },
        '&:hover span, &:hover path': {
            color: theme.colors.actionMajor[600],
            fill: theme.colors.actionMajor[600],
        },
        '& span, & path': {
            color: theme.colors.actionMajor[500],
            fill: theme.colors.actionMajor[500],
        },
    },
});
